module.exports = __webpack_public_path__ + "img/avatar2.1624464a.png";